import { create } from 'zustand';
import { createJSONStorage, devtools, persist } from 'zustand/middleware';
import { customStorage } from './utils';
import Config from '@/config';
import { AppVersion, GenericState } from '@/types';
import { Nullable, Store } from '@ygoargentina/sdk/api/api.types';

export type StoresState = GenericState & {
  selectedStore: Nullable<Store>;
  stores: Store[];

  setSelectedStore: (store: Nullable<Store>) => void;
  setStores: (stores: Store[]) => void;
};

export const storesInitialState = {
  selectedStore: null,
  stores: [],
};

export const useStoresStore = create<
  StoresState,
  [['zustand/devtools', never], ['zustand/persist', StoresState]]
>(
  devtools(
    persist(
      (set) => ({
        ...storesInitialState,

        setSelectedStore: (store: Nullable<Store>) =>
          set((state) => ({
            ...state,
            selectedStore: store,
          })),
        setStores: (stores: Store[]) =>
          set((state) => ({
            ...state,
            stores,
          })),
        resetStore: () => set(() => storesInitialState),
      }),
      {
        name: `${Config.sessionKey}-stores@${AppVersion}`,
        storage: createJSONStorage<StoresState>(() => customStorage),
      }
    )
  )
);
